module.exports = __webpack_public_path__ + "img/index-doc.80c2f70f.png";